import { useState } from "react";
import { useTranslation } from "../../Translation";
import { textColor } from "../../Resources/CSS/styling";

export const getDatesFromRange = (dateRange) => {
    var fromDate = new Date();
    var toDate = new Date();
    if (dateRange === 'yesterday') {
        fromDate.setDate(fromDate.getDate() - 1);
        fromDate.setHours(0, 0, 0, 0);
        toDate.setDate(toDate.getDate() - 1);
        toDate.setHours(23, 59, 59, 999);
    } else if (dateRange === 'today') {
        fromDate.setHours(0, 0, 0, 0);
        toDate.setHours(23, 59, 59, 999);
    }
    else if (dateRange === 'seven_days') {
        fromDate.setDate(fromDate.getDate() - 7);
        toDate.setDate(toDate.getDate() + 1);
    }
    else if (dateRange === 'thirty_days') {
        fromDate.setDate(fromDate.getDate() - 30);
        toDate.setDate(toDate.getDate() + 1);
    }
    else if (dateRange === 'three_months') {
        fromDate.setDate(fromDate.getDate() - 90);
        toDate.setDate(toDate.getDate() + 1);
    }
    else if (dateRange === 'six_months') {
        fromDate.setDate(fromDate.getDate() - 180);
        toDate.setDate(toDate.getDate() + 1);
    }
    else if (dateRange === 'one_year') {
        fromDate.setDate(fromDate.getDate() - 365);
        toDate.setDate(toDate.getDate() + 1);
    }
    return { fromDate, toDate };
}

export default function DateRangeSelection({ value, onChange }) {
    const { translate } = useTranslation();
    const [selectedDateRange, setSelectedDateRange] = useState(value.defaultDateRange || 'thirty_days');


    const handleSelectedDateRangeChange = (dateRange) => {
        const { fromDate, toDate } = getDatesFromRange(dateRange);
        setSelectedDateRange(dateRange);
        onChange({ ...value, fromDate: fromDate, toDate: toDate, defaultDateRange: dateRange });
    }

    return (
        <div className="flex flex-row items-center border border-gray-200 rounded-md divide-x divide-gray-200"> 
            <div onClick={() => handleSelectedDateRangeChange('yesterday')} className={`flex flex-col py-2 px-4 cursor-pointer ${selectedDateRange === 'yesterday' ? `${textColor} bg-gray-50 font-bold` : 'text-gray-400'}`}>
                <span >{translate('date_range.yesterday')}</span>
            </div>
            <div onClick={() => handleSelectedDateRangeChange('today')} className={`flex flex-col py-2 px-4 cursor-pointer ${selectedDateRange === 'today' ? `${textColor} bg-gray-50 font-bold` : 'text-gray-400'}`}>
                <span >{translate('date_range.today')}</span>
            </div>
            <div onClick={() => handleSelectedDateRangeChange('seven_days')} className={`flex flex-col py-2 px-4 cursor-pointer ${selectedDateRange === 'seven_days' ? `${textColor} bg-gray-50 font-bold` : 'text-gray-400'}`}>
                <span >{translate('date_range.seven_days')}</span>
            </div>
            <div onClick={() => handleSelectedDateRangeChange('thirty_days')} className={`flex flex-col py-2 px-4 cursor-pointer ${selectedDateRange === 'thirty_days' ? `${textColor} bg-gray-50 font-bold` : 'text-gray-400'}`}>
                <span >{translate('date_range.thirty_days')}</span>
            </div>
            <div onClick={() => handleSelectedDateRangeChange('three_months')} className={`flex flex-col py-2 px-4 cursor-pointer ${selectedDateRange === 'three_months' ? `${textColor} bg-gray-50 font-bold` : 'text-gray-400'}`}>
                <span >{translate('date_range.three_months')}</span>
            </div>
            <div onClick={() => handleSelectedDateRangeChange('six_months')} className={`flex flex-col py-2 px-4 cursor-pointer ${selectedDateRange === 'six_months' ? `${textColor} bg-gray-50 font-bold` : 'text-gray-400'}`}>
                <span >{translate('date_range.six_months')}</span>
            </div>
            <div onClick={() => handleSelectedDateRangeChange('one_year')} className={`flex flex-col py-2 px-4 cursor-pointer ${selectedDateRange === 'one_year' ? `${textColor} bg-gray-50 font-bold` : 'text-gray-400'}`}>
                <span >{translate('date_range.1_year')}</span>
            </div>
        </div>
    )
}